import { useAuth } from '../context/AuthContext';

/**
 * Zentrale Tier-/Capability-Schicht (eine Quelle der Wahrheit).
 *
 * Leitet aus dem Auth-Zustand ab, was der aktuelle Nutzer darf. Gäste (ohne
 * Login) entsprechen dem kostenlosen Tier: nur Quick Starts + Presenter für
 * global freigegebene „Umsonst"-Workouts.
 *
 * Spätere mehrstufige Bezahloptionen erweitern `plan` (z. B. 'pro'/'studio')
 * und die unten abgeleiteten Flags – ohne dass Aufrufer angepasst werden müssen.
 */
export function getCapabilities(user) {
  const isGuest = !user;
  const role = user?.role || null;
  const plan = isGuest ? 'free' : 'full';

  return {
    isGuest,
    role,
    plan,
    // Gratis-Tier (auch ohne Login)
    quickStarts: true,
    freeWorkouts: true,
    // Bezahl-/Login-Funktionen
    ownWorkouts: !isGuest && ['admin', 'trainer', 'participant', 'super_admin'].includes(role),
    workoutBuilder: !isGuest && ['admin', 'trainer', 'super_admin'].includes(role),
    exercises: !isGuest && ['admin', 'trainer', 'participant', 'super_admin'].includes(role),
    presenter: !isGuest && ['admin', 'trainer', 'participant'].includes(role),
    settings: role === 'admin',
  };
}

export function useCapabilities() {
  const { user } = useAuth();
  return getCapabilities(user);
}
